import css from '@styled-system/css';
import { ThemeStyles } from '@honda-canada/design-system-react';
import variant from '@styled-system/variant';
import { ACURA_SITE_NAME, HONDA_SITE_NAME } from '../../../utils/constants';

const themeStyles = new ThemeStyles();

themeStyles.addBaseStyles('Container')(
  css({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    px: 's',
    py: 's',
  }),
);

themeStyles.addBaseStyles('DealerStatusContainer')(
  css({
    display: 'flex',
    flexDirection: 'column',
    gap: 'xs',
    justifyContent: 'center',
    marginLeft: 'xxs',
  }),
);

themeStyles.addBaseStyles('DealerNameLink')(
  css({
    maxWidth: '200px',
    textDecoration: 'underline',
    display: 'inline-block',
    hyphens: 'auto',
    overflowWrap: 'break-word',
  }),
  variant({
    variants: {
      [HONDA_SITE_NAME]: {
        fontFamily: 'bold',
      },
      [ACURA_SITE_NAME]: {
        fontFamily: 'heading',
      },
    },
    mr: 'xxs',
  }),
);

themeStyles.addBaseStyles('DealerHoursContainer')(
  variant({
    variants: {
      [HONDA_SITE_NAME]: {
        '& span': {
          fontFamily: ['default'],
        },
      },
      [ACURA_SITE_NAME]: {
        '& span': {
          fontFamily: ['headingRegular'],
        },
      },
    },
    mr: 'xxs',
  }),
);

export default themeStyles;
